import React from 'react';
import { UI } from 'src/apps/invest/common/shells/UI';
import { useSurveyBannerModel } from 'src/apps/invest/survey-banner/models/SurveyBannerModel';
import { usePropertiesDashboardViewModel } from '../../models/PropertyDashboardViewModel';
import { Loading } from '../common/Loading';
import { CompleteYourProfile } from './CompleteYourProfile';
import { PropertiesList } from './PropertiesList';

export const PropertyDashboardPage: React.FC = () => {
  const viewModel = usePropertiesDashboardViewModel();
  const surveyBannerModel = useSurveyBannerModel();
  // Don't force the user to finish tasks if the only thing left is the accreditation step. This is optional.
  const needsToCompleteSurvey =
    surveyBannerModel.steps.length > 0 &&
    !(
      surveyBannerModel.steps.length === 2 &&
      surveyBannerModel.steps.every((x) => ['CONFIGURE_INVESTOR', 'ACCREDITATION'].includes(x))
    );
  if (needsToCompleteSurvey) return <CompleteYourProfile />;

  switch (viewModel.pageState) {
    case 'PROPERTIES':
      return <PropertiesList />;
    case 'LOADING':
      return (
        <UI>
          <Loading />
        </UI>
      );
    default:
      throw new Error(`Something went wrong`);
  }
};
